import React from 'react';
import { Typography } from 'antd';
import { useModalMethods } from '../../../../shared/packages/modalManager';
import { modalNames } from '../../../../shared/configs/modal';
import Box from '../../../../shared/ui/Box';
import { roomAcceptanceStatusIdsMap } from '../../../../../../constants/room/lifeCycle';
import { Table } from '../../../base/Table';
import { useCanChangeLifeCycle } from '../../services/accessesProvider';
import LifeCycleWrapper from '../LifeCycleWrapper';

const statusToBg = {
  [roomAcceptanceStatusIdsMap.notAccepted]: '#eb5757',
  [roomAcceptanceStatusIdsMap.acceptedWithComments]: '#27ae60',
  [roomAcceptanceStatusIdsMap.accepted]: '#219653',
};

const statusToColor = {
  [roomAcceptanceStatusIdsMap.notAccepted]: '#fff',
  [roomAcceptanceStatusIdsMap.acceptedWithComments]: '#fff',
  [roomAcceptanceStatusIdsMap.accepted]: '#fff',
};

const AcceptanceStatusCell = ({ record, column, row }) => {
  const { open } = useModalMethods();

  const status = record.recordInfo?.acceptanceStatusAddressLifeCycle;

  const canChange = useCanChangeLifeCycle();

  const handleClick = canChange
    ? () => {
        open(modalNames.changeRoomAcceptanceStatus, { room: record });
      }
    : undefined;

  const Component = status ? Box : Typography.Text;

  const text = status?.name || 'Не установлено';

  const componentProps = status
    ? {
        bgColor: statusToBg[status.id],
        color: statusToColor[status.id] ?? '#000',
      }
    : undefined;

  return (
    <Table.BodyCell
      column={column}
      row={row}
      type={!status ? 'default' : undefined}
    >
      <LifeCycleWrapper
        tooltipTitle={canChange ? 'Изменить результат приемки' : undefined}
      >
        <Component {...componentProps} onClick={handleClick}>
          {text}
        </Component>
      </LifeCycleWrapper>
    </Table.BodyCell>
  );
};

export default AcceptanceStatusCell;
